import { useIntl } from "react-intl";
import { SimpleEntityGridColumn } from "../../../../components/grid/SimpleEntityGrid";

const useSiteGridAnalyseColumns = () => {
    const { formatMessage } = useIntl();

    const gridColumns: Array<SimpleEntityGridColumn> = [
        {
            field: "domain",
            headerName: formatMessage({ id: "sites.grid.col.domain" }),
            pinned: "left",
            maxWidth: 280,
        },
        {
            field: "pbn",
            pinned: "left",
            minWidth: 100,
            maxWidth: 100,
            headerName: formatMessage({ id: "sites.grid.col.pbn" }),
        },
        {
            field: "thematic",
            headerName: formatMessage({ id: "sites.grid.col.thematic" }),
            minWidth: 107,
            maxWidth: 107,
        },
        {
            field: "po",
            headerName: formatMessage({ id: "sites.grid.col.po" }),
            filter: "agNumberColumnFilter",
            valueGetter: ({ data }) => data.po || 0,
            cellClass: "number-cell",
            minWidth: 80,
            maxWidth: 80,
        },
        {
            headerName: formatMessage({ id: "sites.grid.col.keyword" }),
            children: [
                {
                    field: "avg12",
                    headerName: formatMessage({ id: "sites.grid.col.avg12" }),
                    valueGetter: ({ data }) => data.avg12,
                    filter: "agNumberColumnFilter",
                    cellClass: "number-cell",
                    minWidth: 100,
                    maxWidth: 100,
                },
                {
                    field: "avg5",
                    headerName: formatMessage({ id: "sites.grid.col.avg5" }),
                    valueGetter: ({ data }) => data.avg5,
                    filter: "agNumberColumnFilter",
                    cellClass: "number-cell",
                    minWidth: 100,
                    maxWidth: 100,
                },
                {
                    field: "avg4",
                    headerName: formatMessage({ id: "sites.grid.col.avg4" }),
                    valueGetter: ({ data }) => data.avg4,
                    filter: "agNumberColumnFilter",
                    cellClass: "number-cell",
                    minWidth: 100,
                    maxWidth: 100,
                },
                {
                    field: "avg3",
                    headerName: formatMessage({ id: "sites.grid.col.avg3" }),
                    valueGetter: ({ data }) => data.avg3,
                    filter: "agNumberColumnFilter",
                    cellClass: "number-cell",
                    minWidth: 100,
                    maxWidth: 100,
                },
                {
                    field: "avg2",
                    headerName: formatMessage({ id: "sites.grid.col.avg2" }),
                    valueGetter: ({ data }) => data.avg2,
                    filter: "agNumberColumnFilter",
                    cellClass: "number-cell",
                    minWidth: 100,
                    maxWidth: 100,
                },
                {
                    field: "avg1",
                    headerName: formatMessage({ id: "sites.grid.col.avg1" }),
                    valueGetter: ({ data }) => data.avg1,
                    filter: "agNumberColumnFilter",
                    cellClass: "number-cell",
                    minWidth: 100,
                    maxWidth: 100,
                },
                {
                    field: "thisMonth",
                    headerName: formatMessage({ id: "sites.grid.col.thisMonth" }),
                    valueGetter: ({ data }) => data.thisMonth,
                    filter: "agNumberColumnFilter",
                    cellClass: "number-cell",
                    minWidth: 100,
                    maxWidth: 100,
                },
            ],
        },
        {
            headerName: formatMessage({ id: "sites.grid.col.Keyworddifference" }),
            children: [
                {
                    field: "thisMonth-avg1",
                    headerName: formatMessage({ id: "sites.grid.col.thisMonth-avg1" }),
                    valueGetter: ({ data }) => {
                        return data.thisMonth - data.avg1;
                    },
                    cellStyle: ({ data }) => {
                        if (data.thisMonth - data.avg1 > 0) return { backgroundColor: "#76d54b" };
                        if (data.thisMonth - data.avg1 < 0) return { backgroundColor: "#d63031" };
                    },
                    filter: "agNumberColumnFilter",
                    cellClass: "number-cell",
                    minWidth: 100,
                    maxWidth: 100,
                },
                {
                    field: "thisMonth-avg3",
                    headerName: formatMessage({ id: "sites.grid.col.thisMonth-avg3" }),
                    valueGetter: ({ data }) => {
                        return data.thisMonth - data.avg3;
                    },
                    cellStyle: ({ data }) => {
                        if (data.thisMonth - data.avg3 > 0) return { backgroundColor: "#76d54b" };
                        if (data.thisMonth - data.avg3 < 0) return { backgroundColor: "#d63031" };
                    },
                    filter: "agNumberColumnFilter",
                    cellClass: "number-cell",
                    minWidth: 100,
                    maxWidth: 100,
                },
                {
                    field: "thisMonth-avg5",
                    headerName: formatMessage({ id: "sites.grid.col.thisMonth-avg5" }),
                    valueGetter: ({ data }) => {
                        return data.thisMonth - data.avg5;
                    },
                    cellStyle: ({ data }) => {
                        if (data.thisMonth - data.avg5 > 0) return { backgroundColor: "#76d54b" };
                        if (data.thisMonth - data.avg5 < 0) return { backgroundColor: "#d63031" };
                    },
                    filter: "agNumberColumnFilter",
                    cellClass: "number-cell",
                    minWidth: 100,
                    maxWidth: 100,
                },
                {
                    field: "thisMonth-avg12",
                    headerName: formatMessage({ id: "sites.grid.col.thisMonth-avg12" }),
                    valueGetter: ({ data }) => {
                        return data.thisMonth - data.avg12;
                    },
                    cellStyle: ({ data }) => {
                        if (data.thisMonth - data.avg12 > 0) return { backgroundColor: "#76d54b" };
                        if (data.thisMonth - data.avg12 < 0) return { backgroundColor: "#d63031" };
                    },
                    filter: "agNumberColumnFilter",
                    cellClass: "number-cell",
                    minWidth: 100,
                    maxWidth: 100,
                },
            ],
        },

        {
            field: "traffic",
            headerName: formatMessage({ id: "sites.grid.col.traffic" }),
            filter: "agNumberColumnFilter",
            cellClass: "number-cell",
            minWidth: 100,
            maxWidth: 100,
        },
    ];

    return gridColumns;
};

export default useSiteGridAnalyseColumns;
